import { useState } from "react";
import axios from "axios";
import MainLayout from "./layouts/MainLayout";

function AddUser() {

  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [roleId, setRoleId] = useState("");

  const saveUser = async (e) => {

    e.preventDefault();

    try{

      const token = localStorage.getItem("token");

      const response = await axios.post(

        "https://saleupcall.com/api/register.php",

        {
          username,
          email,
          password,
          role_id: roleId
        },

        {
          headers:{
            Authorization:`Bearer ${token}`
          }
        }

      );

      console.log(response.data);

      if(response.data.status){

        alert("User Created");

        setUsername("");
        setEmail("");
        setPassword("");
        setRoleId("");

      }
      else{

        alert(response.data.message);

      }

    }
    catch(error){

      console.log(error);

    }

  };

  return(

    <MainLayout>

      <div style={{padding:"20px"}}>

        <h2>Add User</h2>

        <form onSubmit={saveUser}>

          <input
            type="text"
            placeholder="Username"
            value={username}
            onChange={(e)=>setUsername(e.target.value)}
          />

          <br/><br/>

          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e)=>setEmail(e.target.value)}
          />

          <br/><br/>

          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e)=>setPassword(e.target.value)}
          />

          <br/><br/>

          <select
            value={roleId}
            onChange={(e)=>setRoleId(e.target.value)}
          >

            <option value="">
              Select Role
            </option>

            <option value="2">
              Manager
            </option>

            <option value="3">
              Technician
            </option>

            <option value="4">
              Client
            </option>

          </select>

          <br/><br/>

          <button type="submit">

            Save User

          </button>

        </form>

      </div>

    </MainLayout>

  );

}

export default AddUser;